<script>
import QuizMeta from './QuizMeta.vue';
import QuizGuessAnswers from './QuizGuessAnswers.vue';
import QuizMultiChoices from './QuizMultiChoices.vue';
import QuizImageChoices from './QuizImageChoices.vue';
import QuizAuthPrompt from './QuizAuthPrompt.vue';
import QuizLeaderboard from './QuizLeaderboard.vue';
import QuizResultCard from './QuizResultCard.vue';
import BusyElement from './BusyElement.vue';
import Swal from 'sweetalert2';
export default {
    components: { QuizMeta, QuizGuessAnswers, QuizMultiChoices, QuizImageChoices, QuizAuthPrompt, QuizLeaderboard, QuizResultCard, BusyElement },
    data() {
        return {
            quizOptions: null,
            quizTitle: '',
            quizStarted: false,
            quizTimedOut: false,
            quizQuitted: false,
            quizEnded: false,
            quizScore: null,
            challengeFriendModal: false,
            challengeFriendForm: {
                toEmail: '',
                fromEmail: '',
                fromName: '',
                password: '',
            },
            isFormBusy: false,
            // v2.0.0 — post-quiz auth + results
            showAuthPrompt: false,
            showResults: false,
            authBusy: false,
            authError: '',
            authedName: '',
            leaderboard: [],
            linkCopied: false,
        }
    },
    props: {
        id: {
            type: [String, Number],
            default(rawProp) {
                return rawProp.id ? rawProp.id : null;
            },
            required: true,
        },
    },
    methods: {
        fetchQuizData() {
            let component = this;
            let requestArgs = {};
            requestArgs.post_id = component.id;
            component.ajax('aktion_get_quiz_options', requestArgs).then(function (response) {
                if (response.success) {
                    if (response.data && response.data.quiz_options) {
                        component.quizOptions = { ...JSON.parse(response.data.quiz_options) };
                    }
                    if (response.data && response.data.quiz_title) {
                        component.quizTitle = response.data.quiz_title;
                    }
                } else if (response.data && response.data.message) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: response.data.message,
                        confirmButtonText: 'Close'
                    })
                }
            }, function (error) {
                console.error(`${error.name}: ${error.message}`);
            });
        },
        createQuizEntry() {
            let component = this;
            let requestArgs = {};
            requestArgs.post_id = component.id;
            requestArgs.score = component.quizScore || 0;
            requestArgs.max_score = component.maxScore;
            requestArgs.page_url = window.location.href;
            component.ajax('aktion_create_quiz_entry', requestArgs).then(function (response) {
                if (response.success) {
                    // Logged-in users have their score stored already — go straight
                    // to results. Everyone else sees the register/login prompt first.
                    let loggedIn = component.isUserLoggedIn() || (response.data && response.data.is_user_logged_in);
                    if (loggedIn) {
                        component.revealResults();
                    } else {
                        component.showAuthPrompt = true;
                    }
                } else if (response.data && response.data.message) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: response.data.message,
                        confirmButtonText: 'Close'
                    });
                    component.revealResults();
                }
            }, function (error) {
                console.error(`${error.name}: ${error.message}`);
                component.revealResults();
            });
        },
        revealResults() {
            let component = this;
            component.showAuthPrompt = false;
            component.showResults = true;
            if (!component.leaderboard || component.leaderboard.length === 0) {
                component.loadLeaderboard();
            }
        },
        loadLeaderboard() {
            let component = this;
            component.ajax('aktion_get_quiz_leaderboard', { quiz_id: component.id }).then(function (response) {
                if (response.success && response.data && response.data.leaderboard) {
                    component.leaderboard = response.data.leaderboard;
                }
            }, function (error) {
                console.error(`${error.name}: ${error.message}`);
            });
        },
        applyAuthResponse(response) {
            let component = this;
            if (response.data && response.data.nonce && window.aktionCustomQuizAjax) {
                // Refresh the nonce for the freshly-authenticated session.
                window.aktionCustomQuizAjax.nonce = response.data.nonce;
                window.aktionCustomQuizAjax.is_user_logged_in = true;
            }
            if (response.data && response.data.display_name) {
                component.authedName = response.data.display_name;
            }
            if (response.data && response.data.leaderboard) {
                component.leaderboard = response.data.leaderboard;
            }
            component.revealResults();
        },
        onAuthRegister(payload) {
            let component = this;
            component.authError = '';
            component.authBusy = true;
            let requestArgs = {
                post_id: component.id,
                score: component.quizScore || 0,
                max_score: component.maxScore,
                page_url: window.location.href,
                email: payload.email,
                password: payload.password,
                name: payload.name,
            };
            component.ajax('aktion_register_user', requestArgs).then(function (response) {
                component.authBusy = false;
                if (response.success) {
                    component.applyAuthResponse(response);
                } else {
                    component.authError = (response.data && response.data.message) ? response.data.message : 'Registration failed';
                }
            }, function (error) {
                component.authBusy = false;
                component.authError = 'Something went wrong. Please try again.';
                console.error(`${error.name}: ${error.message}`);
            });
        },
        onAuthLogin(payload) {
            let component = this;
            component.authError = '';
            component.authBusy = true;
            let requestArgs = {
                post_id: component.id,
                score: component.quizScore || 0,
                max_score: component.maxScore,
                page_url: window.location.href,
                login: payload.login,
                password: payload.password,
            };
            component.ajax('aktion_login_user', requestArgs).then(function (response) {
                component.authBusy = false;
                if (response.success) {
                    component.applyAuthResponse(response);
                } else {
                    component.authError = (response.data && response.data.message) ? response.data.message : 'Login failed';
                }
            }, function (error) {
                component.authBusy = false;
                component.authError = 'Something went wrong. Please try again.';
                console.error(`${error.name}: ${error.message}`);
            });
        },
        onAuthSkip() {
            this.revealResults();
        },
        copyShareLink() {
            let component = this;
            let url = window.location.href;
            let done = function () {
                component.linkCopied = true;
                setTimeout(function () { component.linkCopied = false; }, 2500);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
            } else {
                window.prompt('Copy this link:', url);
            }
        },
        onQuizStart(startState) {
            let component = this;
            if (!component.quizStarted && startState) {
                component.quizStarted = startState;
            }
        },
        onQuizScoreUpdate(quizScore) {
            this.quizScore = quizScore;
        },
        onQuizTimeOut() {
            this.quizTimedOut = true;
        },
        onQuizEnded() {
            if (this.quizEnded == false) {
                this.quizEnded = true;
                this.createQuizEntry();
            }
        },
        onQuizQuitted() {
            this.quizQuitted = true;
        },
        openChallengeFriendModal() {
            let component = this;
            component.challengeFriendModal = true;
        },
        closeChallengeFriendModal() {
            let component = this;
            component.challengeFriendModal = false;
        },
        onChallengeModalOpen() {
            let component = this;
            component.openChallengeFriendModal();
        },
        onChallengeFriend() {
            let component = this;

            if (!component.challengeFriendForm.toEmail) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Recipient email is required',
                    confirmButtonText: 'Close'
                });
                return;
            }

            if (!component.challengeFriendForm.fromName) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'User Name is required',
                    confirmButtonText: 'Close'
                });
                return;
            }

            if (!component.challengeFriendForm.fromEmail && component.isUserLoggedIn() == false) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'User email is required',
                    confirmButtonText: 'Close'
                });
                return;
            }

            if (!component.challengeFriendForm.password && component.isUserLoggedIn() == false) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'User password is required',
                    confirmButtonText: 'Close'
                });
                return;
            }

            let isToEmailValid = true;
            let isFromEmailValid = true;
            let areEmailsUnique = true;
            let isPasswordValid = true;

            let toEmails = component.challengeFriendForm.toEmail.includes(',') ? component.challengeFriendForm.toEmail.split(',').map(x => x.replace(' ', '')) : component.challengeFriendForm.toEmail;
            let fromEmail = component.challengeFriendForm.fromEmail;
            let fromName = component.challengeFriendForm.fromName;
            let userPassword = component.challengeFriendForm.password;
            if (Array.isArray(toEmails)) {
                toEmails.forEach(function (email) {
                    if (!component.isValidEmail(email)) {
                        isToEmailValid = false;
                    }
                });
            } else if (typeof toEmails === 'string') {
                if (!component.isValidEmail(toEmails)) {
                    isToEmailValid = false;
                }
            }

            if (Array.isArray(toEmails)) {
                toEmails = [...new Set(toEmails)]
                if (toEmails.includes(fromEmail.toLowerCase())) {
                    areEmailsUnique = false
                }
            } else if (typeof toEmails === 'string') {
                if (fromEmail.toLowerCase() == toEmails.toLowerCase()) {
                    areEmailsUnique = false
                }
            }

            if (!component.isValidEmail(fromEmail)) {
                isFromEmailValid = false;
            }

            if (userPassword.length < 8) {
                isPasswordValid = false;
            }

            // validate
            if (isToEmailValid == false) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Invalid recipient email address(es)',
                    confirmButtonText: 'Close'
                });
                return;
            }
            if (isFromEmailValid == false && component.isUserLoggedIn() == false) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Invalid sender email address',
                    confirmButtonText: 'Close'
                });
                return;
            }
            if (areEmailsUnique == false && component.isUserLoggedIn() == false) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Recipient & Sender email must be different',
                    confirmButtonText: 'Close'
                });
                return;
            }
            if (isPasswordValid == false && component.isUserLoggedIn() == false) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Password must be greater than 8 characters',
                    confirmButtonText: 'Close'
                });
                return;
            }
            if (!fromName) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Sender name is required',
                    confirmButtonText: 'Close'
                });
                return;
            }

            // disable form
            component.isFormBusy = true;

            // make request
            let requestArgs = {};
            requestArgs.quiz_id = component.id;
            requestArgs.post_id = component.getCurrentPostId();
            requestArgs.recipient_emails = toEmails;
            requestArgs.sender_email = fromEmail;
            requestArgs.sender_name = fromName;
            requestArgs.user_password = userPassword;
            component.ajax('aktion_challenge_a_friend', requestArgs).then(function (response) {
                if (response.success) {
                    component.closeChallengeFriendModal();
                    Swal.fire({
                        icon: 'success',
                        title: 'Challenge sent.',
                        confirmButtonText: 'Close'
                    })
                } else if (response.data && response.data.message) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: response.data.message,
                        confirmButtonText: 'Close'
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong',
                        confirmButtonText: 'Close'
                    })
                }
                component.isFormBusy = false;
            }, function (error) {
                console.error(`${error.name}: ${error.message}`);
                component.isFormBusy = false;
            });
        },
        openShareWindow(url = null, width = 575, height = 400) {
            if (url) {
                let left = (window.screen.width - width) / 2;
                let top = (window.screen.height - height) / 2;
                let opts = `status=1, width=${width}, height=${height}, top=${top}, left=${left}`;
                window.open(url, 'share', opts);
            }
        },
        onPostShare(site = null) {
            let component = this;
            let pageUrl = window.location.href;
            if (site == 'facebook') {
                let shareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`;
                component.openShareWindow(shareURL);
            } else if (site == 'twitter' || site == 'x') {
                let shareURL = `https://x.com/intent/post?text=${encodeURIComponent(component.shareText)}`;
                component.openShareWindow(shareURL);
            }
        }
    },
    mounted() {
        let component = this;
        component.fetchQuizData();
    },
    computed: {
        areFormFieldsValid() {
            let component = this;
            let isValid = false;
            if (component.isUserLoggedIn()) {
                isValid = component.challengeFriendForm.toEmail && component.challengeFriendForm.fromName;
            } else {
                isValid = component.challengeFriendForm.toEmail && component.challengeFriendForm.fromEmail && component.challengeFriendForm.fromName && component.challengeFriendForm.password;
            }
            return isValid;
        },
        maxScore() {
            return this.quizOptions ? this.computeQuizMaxScore(this.quizOptions) : 0;
        },
        config() {
            return window.aktionCustomQuizAjax || {};
        },
        registrationPrompt() {
            return this.config.registration_prompt || 'Create a free account to save your score and track your progress.';
        },
        shareHashtag() {
            return this.config.share_hashtag || '';
        },
        shareText() {
            let score = this.quizScore || 0;
            let text = `I scored ${score}/${this.maxScore} on '${this.quizTitle}' — can you beat me? ${window.location.href}`;
            if (this.shareHashtag) {
                text += ` #${this.shareHashtag}`;
            }
            return text;
        },
        cardColors() {
            let cfg = this.config;
            let override = (this.quizOptions && this.quizOptions.resultCardColors) || {};
            let useOverride = !!override.enabled;
            return {
                bgStart: (useOverride && override.bgStart) || cfg.card_bg_start || '#4c1d95',
                bgEnd: (useOverride && override.bgEnd) || cfg.card_bg_end || '#7c3aed',
                accent: (useOverride && override.accent) || cfg.card_accent || '#fde047',
            };
        }
    }
}
</script>
<template>
    <div v-if="quizOptions && quizOptions.quizType">
        <QuizMeta :quizOptions="quizOptions"/>
        <QuizGuessAnswers
            v-if="quizOptions.quizType == 'guess-answers'"
            :quizOptions="quizOptions"
            @quiz-started="onQuizStart"
            @quiz-score-updated="onQuizScoreUpdate"
            @quiz-timed-out="onQuizTimeOut"
            @quiz-ended="onQuizEnded"
            @quiz-quitted="onQuizQuitted"
            @open-challenge-modal="onChallengeModalOpen"
        />
        <QuizMultiChoices
            v-else-if="quizOptions.quizType == 'multi-choice'"
            :quizOptions="quizOptions"
            @quiz-started="onQuizStart"
            @quiz-score-updated="onQuizScoreUpdate"
            @quiz-timed-out="onQuizTimeOut"
            @quiz-ended="onQuizEnded"
            @quiz-quitted="onQuizQuitted"
            @open-challenge-modal="onChallengeModalOpen"
        />
        <QuizImageChoices
            v-else-if="quizOptions.quizType == 'multi-choice-images'"
            :quizOptions="quizOptions"
            @quiz-started="onQuizStart"
            @quiz-score-updated="onQuizScoreUpdate"
            @quiz-timed-out="onQuizTimeOut"
            @quiz-ended="onQuizEnded"
            @quiz-quitted="onQuizQuitted"
            @open-challenge-modal="onChallengeModalOpen"
        />
    </div>
    <div v-else class="quiz-form-preloader-wrap">
        <div class="quiz-form-preloader"></div>
    </div>

    <!-- v2.0.0: post-quiz registration prompt -->
    <QuizAuthPrompt
        v-if="showAuthPrompt"
        :message="registrationPrompt"
        :isBusy="authBusy"
        :errorMessage="authError"
        @register="onAuthRegister"
        @login="onAuthLogin"
        @skip="onAuthSkip"
    />

    <!-- v2.0.0: results, sharing & leaderboard -->
    <div v-if="showResults" class="aktion-quiz-results">
        <p v-if="authedName" class="aktion-quiz-results__welcome">Score saved for {{ authedName }}!</p>

        <div class="aktion-quiz-results__share">
            <h3>Share your score</h3>
            <div class="aktion-quiz-results__share-buttons">
                <button type="button" class="aktion-quiz-share-btn aktion-quiz-share-btn--x" @click="onPostShare('x')">Share on X</button>
                <button type="button" class="aktion-quiz-share-btn aktion-quiz-share-btn--fb" @click="onPostShare('facebook')">Share on Facebook</button>
                <button type="button" class="aktion-quiz-share-btn aktion-quiz-share-btn--copy" @click="copyShareLink">{{ linkCopied ? 'Link copied!' : 'Copy Link' }}</button>
            </div>
        </div>

        <QuizResultCard
            :quizTitle="quizTitle"
            :score="quizScore || 0"
            :maxScore="maxScore"
            :siteName="config.site_name || ''"
            :siteLogo="config.site_logo || ''"
            :siteUrl="config.site_url || ''"
            :bgStart="cardColors.bgStart"
            :bgEnd="cardColors.bgEnd"
            :accent="cardColors.accent"
        />

        <QuizLeaderboard :entries="leaderboard" title="Leaderboard" />
    </div>

    <vue-final-modal
        v-model="challengeFriendModal"
        :attach="'body'"
        classes="modal--container"
        content-class="modal--content"
        :content-style="{ height: 'auto' }"
        :click-to-close="false"
    >
        <BusyElement cssClasses="inner-wrapper" :isBusy="isFormBusy">
            <div class="modal-header">
                <div class="modal-header-content">
                    <h2>Challenge Your Friends!</h2>
                </div>
                <button type="button" class="modal-close-btn" title="close modal" @click="closeChallengeFriendModal">Close</button>
            </div>
            <div class="modal-form">
                <form @submit.prevent="onChallengeFriend">
                    <div class="form-field">
                        <p class="form-field-label">
                            <label>To:</label>
                        </p>
                        <input class="input" type="text" placeholder="Email Address(es)" v-model="challengeFriendForm.toEmail" required>
                    </div>
                    
                    <div class="form-field">
                        <p class="form-field-label">
                            <label>From:</label>
                        </p>
                        <input class="input" type="text" placeholder="Your Name (share with friends)" v-model="challengeFriendForm.fromName" required>
                        <input class="input" type="text" placeholder="Your Email Address" v-if="!isUserLoggedIn()" v-model="challengeFriendForm.fromEmail" required>
                        <input class="input" type="password" placeholder="Your Password" v-if="!isUserLoggedIn()" v-model="challengeFriendForm.password" required>
                    </div>

                    <div class="form-footer">
                        <button class="form-submit" :disabled="areFormFieldsValid == false">SEND NOW!</button>
                    </div>
                </form>
            </div>  
        </BusyElement>
        <div class="share-divider">
            <div class="share-dash"></div>
            <div class="share-text">or</div>
            <div class="share-dash"></div>
        </div>
        <div class="share-button-wrapper">
            <button type="button" class="share-button facebook-share" @click="onPostShare('facebook')">
                <div class="button-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
	<path fill="#ffffff" opacity="1.000000" stroke="none" d="
M389.531342,1.000000 
	C391.702423,3.572252 394.812897,4.524345 396.758087,6.739003 
	C400.919617,11.477062 403.451355,16.813593 403.410797,23.424168 
	C403.255432,48.742489 402.997559,74.069183 403.492706,99.378777 
	C403.747986,112.427582 391.116028,124.782722 378.465271,124.445045 
	C364.316559,124.067383 350.148590,124.469032 335.992096,124.287315 
	C332.110687,124.237488 328.386322,125.003860 324.637146,125.548416 
	C318.396973,126.454788 317.681366,131.818954 317.514069,136.541794 
	C317.130981,147.355652 317.407806,158.191910 317.345337,169.018646 
	C317.323395,172.820068 319.886597,172.658936 322.477844,172.658005 
	C339.468414,172.651917 356.460388,172.528641 373.449066,172.708389 
	C385.214417,172.832886 394.282074,177.523560 399.056152,188.961472 
	C399.988586,191.195419 400.356781,193.365417 400.354828,195.723114 
	C400.331696,223.707565 399.971008,251.699387 400.530487,279.672668 
	C400.739502,290.122284 388.830139,303.661743 376.886810,303.441223 
	C359.069427,303.112152 341.239258,303.508423 323.419556,303.249969 
	C318.502808,303.178680 317.252563,304.870056 317.263458,309.576569 
	C317.397369,367.377472 317.127625,425.180328 317.514557,482.978973 
	C317.603943,496.334137 313.317169,506.199921 301.230896,512.758789 
	C267.645782,513.000000 234.291550,513.000000 200.468658,513.000000 
	C192.421478,508.413544 185.998520,502.973999 184.215866,493.574524 
	C183.741089,491.071228 183.669128,488.628510 183.668091,486.154388 
	C183.643707,427.508484 183.650345,368.862549 183.646713,310.216644 
	C183.646301,303.389496 183.633804,303.372345 176.814362,303.365692 
	C163.652374,303.352875 150.474777,302.959412 137.332520,303.468536 
	C122.713623,304.034912 110.896141,293.319244 110.736237,277.442078 
	C110.469460,250.954178 110.476944,224.459656 110.747429,197.971786 
	C110.893898,183.627899 122.366676,172.828934 136.945084,172.691727 
	C150.605759,172.563171 164.270325,172.530106 177.929260,172.727524 
	C182.245850,172.789917 183.817719,171.397202 183.728561,166.987549 
	C183.492859,155.329788 183.506378,143.661987 183.677612,132.001968 
	C184.115921,102.155312 190.735168,74.014641 208.428345,49.437145 
	C225.503616,25.717966 248.744232,10.816450 277.030762,3.686360 
	C279.253693,3.126029 281.629089,3.005371 283.784912,1.282183 
	C319.020905,1.000000 354.041779,1.000000 389.531342,1.000000 
M286.770752,124.816505 
	C289.759583,111.917519 296.401245,101.920456 309.211670,96.987968 
	C316.225067,94.287567 323.592133,92.895775 331.065125,92.731766 
	C342.890747,92.472221 354.728119,92.532082 366.556274,92.721138 
	C370.517975,92.784462 371.751404,91.363235 371.715302,87.483826 
	C371.558746,70.654892 371.522308,53.822174 371.728760,36.994347 
	C371.783234,32.556824 370.234161,31.258745 365.928802,31.305019 
	C348.767212,31.489483 331.599823,31.552505 314.439514,31.310066 
	C300.661774,31.115416 287.398132,33.395313 274.529724,38.194885 
	C253.574265,46.010723 237.873459,59.702217 227.673981,79.722961 
	C219.120377,96.512970 215.686569,114.462303 215.407043,133.073761 
	C215.139313,150.899948 215.364853,168.733307 215.342072,186.563477 
	C215.327911,197.647430 208.750397,204.322586 197.770905,204.350098 
	C181.107269,204.391830 164.442642,204.458984 147.780319,204.307159 
	C143.713959,204.270111 142.230591,205.572952 142.269684,209.761002 
	C142.445419,228.589401 142.447525,247.421249 142.275116,266.249664 
	C142.237030,270.408142 143.628586,271.745392 147.742889,271.700928 
	C163.571503,271.529877 179.413498,271.998413 195.230515,271.539429 
	C208.138458,271.164886 215.604309,280.582062 215.532761,291.903748 
	C215.146271,353.057220 215.412003,414.214630 215.234894,475.370026 
	C215.219971,480.521454 216.737610,481.836731 221.737503,481.763611 
	C240.730103,481.485901 259.729187,481.653351 278.725861,481.650055 
	C285.632751,481.648865 285.647705,481.643341 285.648193,474.814453 
	C285.652771,413.658539 285.649963,352.502594 285.653503,291.346680 
	C285.654266,278.399078 292.377380,271.649841 305.273560,271.645996 
	C324.436859,271.640259 343.601685,271.514893 362.762360,271.738586 
	C367.368713,271.792358 368.803436,270.389465 368.747437,265.772064 
	C368.523285,247.278046 368.520782,228.777969 368.755798,210.284180 
	C368.814575,205.658585 367.360809,204.238159 362.780273,204.283707 
	C342.785767,204.482529 322.788116,204.395874 302.791718,204.354523 
	C292.865234,204.333984 285.539764,197.317001 285.703461,187.558090 
	C286.049500,166.933929 284.527496,146.278442 286.770752,124.816505 
z" />
</svg>
</div>
                <div class="button-text">Share on Facebook</div>
            </button>
            <button type="button" class="share-button twitter-share" @click="onPostShare('twitter')">
                <div class="button-icon"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
	<path fill="#ffffff" opacity="1.000000" stroke="none" d="
M513.000000,112.000000 
	C513.000000,116.024544 513.000000,120.049088 512.814697,124.817871 
	C506.551544,135.284073 500.397308,144.959488 494.426727,154.746918 
	C491.260590,159.936996 487.416199,164.813019 488.395752,171.690430 
	C491.084412,190.567490 492.774536,209.422836 491.648041,228.641434 
	C490.574127,246.962921 488.204285,264.939514 483.750732,282.666412 
	C472.658234,326.818573 450.385590,365.009552 420.325104,398.707489 
	C398.753174,422.889740 373.449005,442.216095 343.522919,455.503265 
	C308.065002,471.246613 270.762329,478.339569 232.426086,480.189911 
	C206.379272,481.447052 180.300598,480.377472 154.363129,476.554688 
	C127.732162,472.629700 101.497261,467.329010 75.950989,458.682129 
	C54.757698,451.508667 34.006077,443.659027 16.869778,428.556152 
	C11.224995,423.581238 9.109927,415.969269 11.795447,408.652496 
	C13.865786,403.011780 19.552883,399.653778 27.040474,399.602142 
	C44.320145,399.482941 61.577671,399.880859 78.837173,397.796143 
	C98.392082,395.434174 116.937706,390.329071 134.131638,380.697632 
	C138.357330,378.330536 142.755249,375.984039 145.847702,372.179810 
	C144.705948,370.144318 143.031891,369.975372 141.688293,369.628174 
	C123.089447,364.822205 105.497017,357.505249 88.641457,348.388916 
	C74.664452,340.829437 62.216640,331.171692 50.882607,320.069916 
	C45.546471,314.843109 43.721298,308.282074 46.013378,301.383850 
	C48.163101,294.914062 53.569637,291.667480 60.345695,290.516693 
	C63.459061,289.987976 66.678345,289.265198 69.792732,287.252838 
	C68.830284,286.453857 68.278885,285.829987 67.592354,285.450684 
	C53.369850,277.592743 40.721081,267.825439 30.104851,255.419815 
	C20.503502,244.200104 12.871582,231.895340 7.615431,218.062714 
	C5.222479,211.765152 4.273381,204.979462 1.000000,199.000000 
	C1.000000,192.978851 1.000000,186.957703 1.303200,180.330658 
	C10.839296,167.572052 22.486174,172.894867 33.408703,176.065781 
	C34.367817,173.905777 33.718906,172.663757 33.190071,171.482880 
	C29.090553,162.328918 26.654192,152.787216 25.445534,142.803680 
	C22.498974,118.465027 25.823782,95.424812 38.854107,74.298256 
	C41.001118,70.817230 42.822266,66.938438 46.557682,64.638351 
	C56.417786,58.566975 66.270691,61.522552 72.410530,72.666321 
	C87.673325,100.368179 107.455627,124.307861 132.324112,143.840515 
	C163.721848,168.501465 199.546280,182.887573 238.976501,188.514435 
	C242.593338,189.030579 244.649887,187.910080 244.679779,183.750214 
	C244.729828,176.783966 244.580841,169.845749 245.455307,162.847336 
	C247.711548,144.790405 253.163620,127.921486 262.346344,112.238098 
	C279.125153,83.581291 303.131531,64.357773 335.821777,57.100327 
	C358.753143,52.009415 381.405457,53.439491 403.086975,63.069099 
	C408.263458,65.368179 412.489685,65.363983 417.593781,62.748886 
	C435.518005,53.565338 453.674530,44.834648 471.759125,35.965145 
	C477.735870,33.033875 483.890594,32.224987 489.903717,35.642910 
	C497.598724,40.016823 499.690094,49.535610 495.154449,58.935982 
	C488.720184,72.271408 482.172577,85.552162 475.746155,98.891312 
	C475.014435,100.410164 473.376740,101.837334 474.662903,104.184578 
	C479.268127,102.998489 484.045349,103.503502 488.817749,102.931107 
	C498.182434,101.807892 507.768311,101.495422 513.000000,112.000000 
M277.373230,192.420410 
	C277.897400,195.855881 278.290710,199.317459 278.969940,202.721985 
	C281.111450,213.455978 273.941315,222.370285 262.952911,222.396393 
	C240.565750,222.449585 218.697281,218.763321 197.215073,212.757828 
	C176.150513,206.869110 156.274170,198.168442 137.523651,186.850250 
	C113.418488,172.299881 92.153595,154.470947 74.218330,132.732330 
	C69.198494,126.647980 64.269699,120.488525 59.358662,114.436867 
	C57.973118,115.065903 57.648193,116.030296 57.520309,117.018219 
	C56.495857,124.932014 56.560097,132.800949 57.934650,140.706284 
	C60.719437,156.722122 67.930351,170.426010 78.705490,182.475586 
	C87.269806,192.052872 84.304932,206.473587 72.864746,209.843430 
	C63.595764,212.573730 53.963585,213.445724 44.286224,211.747482 
	C43.272076,211.569504 42.322346,211.317917 41.569389,212.380585 
	C41.094524,214.194839 42.370594,215.510803 43.113937,216.923477 
	C55.556694,240.569977 75.986427,254.614151 100.029953,264.421051 
	C107.102257,267.305725 114.889374,268.252686 121.489258,272.301666 
	C130.818207,278.024872 130.807632,293.686981 121.425591,299.311523 
	C114.732025,303.324310 108.122246,307.510284 100.934570,310.659760 
	C99.350639,311.353821 97.468521,311.921844 96.635124,314.222473 
	C102.191437,319.013855 108.803009,321.969666 115.364983,325.179901 
	C136.000198,335.275085 157.835495,341.135071 180.408066,344.715668 
	C186.445145,345.673309 192.699768,346.500610 196.342438,352.573608 
	C200.857864,360.101685 199.929871,367.843445 193.322296,374.803009 
	C188.285461,380.108185 182.889893,385.034668 177.406647,389.898376 
	C159.834198,405.485260 139.833771,416.641632 117.388382,423.333527 
	C109.293381,425.746979 100.954056,427.340942 92.478355,429.368134 
	C95.419647,431.424103 98.671669,431.615814 101.644775,432.492950 
	C131.833069,441.399384 162.713791,445.983215 194.122055,447.759277 
	C205.430923,448.398804 216.647522,447.533630 227.897949,447.716553 
	C234.753403,447.828003 241.539825,447.116608 248.268585,446.415985 
	C271.413635,444.006012 294.113342,439.389679 316.062561,431.350983 
	C336.236023,423.962616 354.890015,413.817200 371.404633,400.174835 
	C390.338806,384.533661 406.385315,366.120422 419.978455,345.650543 
	C433.112274,325.872345 443.339691,304.712677 450.053131,281.864166 
	C454.654724,266.203278 457.405975,250.299484 458.870026,234.031479 
	C460.490326,216.027374 459.496765,198.199432 457.008118,180.436401 
	C455.139191,167.096756 453.301941,154.063034 463.347656,142.806213 
	C464.454498,141.565933 464.831848,139.674698 465.999756,137.081116 
	C459.792236,139.347412 454.283600,138.094421 448.826965,139.130737 
	C442.455353,140.340836 436.270813,138.521408 432.296509,133.161621 
	C428.168457,127.594482 427.824158,121.166878 430.957184,114.805298 
	C434.488831,107.634193 438.141541,100.522209 441.618286,93.324936 
	C442.359192,91.791168 443.951965,90.366852 442.948761,88.088875 
	C441.081085,87.147926 439.533203,88.380981 437.971466,89.148239 
	C432.590546,91.791786 427.182312,94.389221 421.894409,97.210266 
	C413.821472,101.517113 406.081970,101.864586 397.860260,97.109039 
	C383.584900,88.851936 368.300446,85.134636 351.587769,87.290482 
	C329.818237,90.098618 312.368225,100.292915 298.595459,116.971733 
	C287.349121,130.591003 280.723267,146.536621 277.934845,163.829819 
	C276.470520,172.911209 274.952271,182.247177 277.373230,192.420410 
z" />
</svg>
</div>
                <div class="button-text">Share on Twitter</div>
            </button>
        </div>
    </vue-final-modal>
</template>